<template>
    <div class="vertical_layout height">
        <div class="template_back template_radius bm_spacing" style="padding-bottom: 15px;" v-if="topStatus">
            <slot name="top"></slot>
        </div>
        <div class="flex layoutHeight" :class="{layoutTopHeight: topStatus}">
            <div class="horizontal_layout_no height">
                <div class="currentLeftModule template_back tblr_spacing height rm_spacing template_radius">
                    <slot name="left"></slot>
                </div>
                <div class="currentRightModule template_back tblr_spacing height flex template_radius" style="width: calc(100% - 315px);">
                    <slot name="right"></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        topStatus: {
            type: Boolean,
            default: true
        }
    }
}
</script>

<style lang="scss">
.layoutHeight {
    height: 100%;
    &.layoutTopHeight {
        height: calc(100% - 82px);
    }

}
</style>


// WEBPACK FOOTER //
// src/components/module/layout/index.vue